import { FC, FunctionComponent, SVGProps, useState } from "react";
import { Link } from "react-router-dom"
import { MenuItem } from "@mui/material"

import { useTheme } from "@hooks/useTheme.ts"
import {
  handleProfileItemStyle,
  sideMenuItem,
} from "./../HeaderProfileMenu/headerProfileMenuStyles"

type MenuItemType = {
  icon: FunctionComponent<SVGProps<SVGSVGElement>>
  alt: {
    ru: string
    en: string
  }
  path: string
  text: string
}

export type HeaderProfileThemeItemProps = {
  item: MenuItemType
  i: number
  isOpenMenu: boolean
}

const HeaderProfileThemeItem: FC<HeaderProfileThemeItemProps> = ({ item, i, isOpenMenu }) => {
  const {  path, icon: Icon, text } = item || {}
  const { isDarkTheme, onToggleTheme } = useTheme()
  const [themeEnabled, setThemeEnabled] = useState<boolean>(false)
  const handleThemeToggle = (): void => {
    setThemeEnabled(!themeEnabled)
    onToggleTheme()
  }

  return (
    <Link
      to={path}
      key={text}
      style={handleProfileItemStyle(i, isOpenMenu)}
      onClick={() => handleThemeToggle()}
    >
      <MenuItem sx={sideMenuItem} >
        <Icon/>
        {text}
        <span style={{color: "var(--Schemes-Primary)"}}>{isDarkTheme ? "Темная" : "Светлая"}</span>
      </MenuItem>
    </Link>
  )
}

export default HeaderProfileThemeItem
